import { render, staticRenderFns } from "./Procedimiento2.vue?vue&type=template&id=c748439c"
import script from "./Procedimiento2.vue?vue&type=script&lang=js"
export * from "./Procedimiento2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports